import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import CircularProgress from '@mui/material/CircularProgress';

interface ConfirmationDialogProps {
    details: {
        open: boolean;
        title: string;
        description: string;
        action: string;
        cancelTitle: string;
        confirmTitle: string;
    };
    setOpen: (open: {
        open: boolean;
        title: string;
        description: string;
        action: string;
        cancelTitle: string;
        confirmTitle: string;
    }) => void;
    handleModalAction: () => void;
    isLoadingSubmit: boolean;
}

export default function ConfirmationDialog({
    details,
    setOpen,
    handleModalAction,
    isLoadingSubmit,
}: ConfirmationDialogProps) {
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const handleClose = () => {
        setOpen({ open: false, title: '', description: '', action: '', cancelTitle: '', confirmTitle: '' });
    };

    return (
        <React.Fragment>
            <Dialog
                fullScreen={fullScreen}
                open={details.open}
                onClose={handleClose}
                sx={{
                    '& .MuiDialog-paper': {
                        width: '670px',
                        maxWidth: '670px',
                    },
                }}>
                <DialogTitle>
                    {details.title}
                </DialogTitle>
                <DialogContent>
                    <DialogContentText
                        sx={{ color: theme.palette.neutralGray.main }}>
                        {details.description}
                    </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'space-between' }}>
                    <Button
                        size="large"
                        disabled={isLoadingSubmit}
                        autoFocus
                        onClick={handleClose}
                        variant="text"
                        color="secondary">
                        {details.cancelTitle}
                    </Button>
                    <Button
                        size="large"
                        onClick={handleModalAction}
                        autoFocus
                        disabled={isLoadingSubmit}
                        color={details.confirmTitle === 'Deactivate' || details.confirmTitle === 'Supprimer' ? 'error' : 'primary'}>
                        {isLoadingSubmit ? <CircularProgress size={24} color="inherit" /> : details.confirmTitle}
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}
